import React, { useContext, useRef } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import CreateCSV from '../../../../../Assets/Modals/CreateCSV.svg';
import Excel from '../../../../../Assets/Modals/Excel.svg';
import { useDispatch } from 'react-redux';
import OptionType from './OptionType';
import { closeModal, setModal } from '../../../../../Features/inventoryManagementSlice';
import { CSVUploadContext } from '../../../../../Context/CSVUploadContext';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';

function ImportHome() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    const { setUploadedFile } = useContext(CSVUploadContext);

    const handleSelectCSV = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadedFile(file);
            dispatch(setModal('upload-csv'));
        }
    }

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleSelectType = (type) => {
        dispatch(setModal(type));
    }

    return (
        <div ref={wrapperRef} className='w-[44%] bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-4'>
            <div className="flex items-center justify-between select-none">
                <h1 className='font-semibold text-2xl text-[#121212]'>Import</h1>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="grid grid-cols-2 gap-x-[9px]">
                <label htmlFor='excel-input' className="cursor-pointer relative outline-none select-none h-[293px] border border-[#EAEAEA] rounded-xl bg-[#FFFFFF] hover:bg-[#EFEFEF] flex items-center justify-center">
                    <div className="w-[100px] h-[100px] flex items-center justify-center">
                        <img src={Excel} alt="" />
                    </div>

                    <h1 className='font-semibold text-[20px] leading-8 text-[#121212] absolute bottom-6 left-1/2 -translate-x-1/2 text-nowrap'>Upload XLSX Template</h1>
                </label>

                <input 
                    id='excel-input' 
                    name='excel-input' 
                    type="file" 
                    accept=".xlsx, .xls" 
                    onChange={handleSelectCSV} 
                    className='hidden'
                />

                <OptionType 
                    icon={CreateCSV} 
                    title={'Create Your Own'} 
                    onClick={() => handleSelectType('create-csv')} 
                />
            </div>
        </div>
    );
}

export default ImportHome;
